export default {
  namespaced: true,
  state: {
    items: [],
    pdfFileUrl: null,
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getPdfFileUrl(state) {
      return state.pdfFileUrl;
    },
  },
  actions: {
    GetList({ commit, rootGetters, dispatch }) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('profiles/api/map/index')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'items', value: response.data.items });
              commit('setField', { name: 'pdfFileUrl', value: response.data.pdf_file_url });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
